import { render, staticRenderFns } from "./SustainabilityProcess_.vue?vue&type=template&id=1548d032&scoped=true&"
import script from "./SustainabilityProcess_.vue?vue&type=script&lang=ts&"
export * from "./SustainabilityProcess_.vue?vue&type=script&lang=ts&"
import style0 from "./SustainabilityProcess_.vue?vue&type=style&index=0&id=1548d032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548d032",
  null
  
)

export default component.exports